export default "__VITE_ASSET__a8064cf6__"